import { FabricinitializeWorker } from '@idmc-ms-fabric/integration';

import ROUTES from './routes/Routes';
import { default as constant, default as constants } from './utils/constants';
import { getWorkloadName } from './utils/manifest-utils';
import { buildURL } from './utils/navigation-utils';

type TItemCreate = {
	workspaceObjectId: string;
};
const initializeWorker: FabricinitializeWorker = async (extensionClient) => {
	extensionClient.action.onAction(({ action, data }) => {
		const { workspaceObjectId } = data as TItemCreate;
		const workloadName = getWorkloadName();
		switch (action) {
			case constant.FABRIC_ACTIONS.OPEN_DATA_SOURCE_SELECTION_VIEW: {
				return extensionClient.page.open({
					workloadName,
					route: {
						path: buildURL(ROUTES.dataSource, { workspaceObjectId }),
						queryParams: { [constants.WORKLOAD_NAME_PARAM]: workloadName },
					},
				});
			}
			case constant.FABRIC_ACTIONS.ARTIFACT_ALREADY_EXISTS: {
				const { itemId } = data as { itemId: string };
				return extensionClient.page.open({
					workloadName: getWorkloadName(),
					route: {
						path: buildURL(ROUTES.dataQuality, { assetId: itemId }),
						queryParams: { [constants.WORKLOAD_NAME_PARAM]: workloadName },
					},
				});
			}
			case constant.FABRIC_ACTIONS.OPEN_UTILITIES_PAGE: {
				return extensionClient.page.open({
					workloadName: getWorkloadName(),
					route: {
						path: buildURL(ROUTES.utilities, { workspaceObjectId }),
						queryParams: { [constants.WORKLOAD_NAME_PARAM]: workloadName },
					},
				});
			}
			case constant.FABRIC_ACTIONS.OPEN_DEV_ONLY: {
				return extensionClient.page.open({
					workloadName: getWorkloadName(),
					route: {
						path: buildURL(ROUTES.dev_only, { workspaceObjectId }),
						queryParams: { [constants.WORKLOAD_NAME_PARAM]: workloadName },
					},
				});
			}
			default:
				throw new Error('Unknown action received');
		}
	});
};

export default initializeWorker;
